module.exports = __webpack_public_path__ + "img/promobi-white.9ff24cd4.svg";